<template>
    <!-- 订单详情 -->
    <div  class="Booking">
    <TopNavigation  class="topNavigation"></TopNavigation>
    <div class="typeArea">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/Order' }">我的订单</el-breadcrumb-item>
            <el-breadcrumb-item class="bread">订单详情</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 订单详情内容 -->
        <div class="detail-content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="订单详情" name="first">
                    <OrderDetails />
                </el-tab-pane>
                <el-tab-pane v-if="showTabFirst"  label="订舱确认" name="fourth">
                    <Confirmation @from-child="getShowTabSecond" :parentMessage='parentMessage' />
                </el-tab-pane>
                <el-tab-pane v-if="showTabSecond"  label="截单确认" name="fifth">
                    <CutOffConfirmation :parentMessage='parentMessage' />
                </el-tab-pane>
                <el-tab-pane v-if="showTabThird"  label="提单确认" name="sixth">
                    <BillOfLadingConfirmation :parentMessage='parentMessage'  />
                </el-tab-pane>
                <el-tab-pane label="订单留言" name="second">
                    <template #label>
                        <el-badge :value="hiddenBadge" :max="99" v-if="hiddenBadge>0">
                        <!-- <el-badge is-dot :hidden="hiddenBadge"> -->
                            <span>订单留言</span>
                        </el-badge>
                        <span v-else>订单留言</span>
                    </template>
                    <LeaveWord :diaoyong="diaoyong" />
                </el-tab-pane>
                <el-tab-pane label="账单明细" name="third">
                    <BillDetails :bill_change="bill_change" />
                </el-tab-pane>
            </el-tabs>

        </div>
    </div>
    <Bottom />
    </div>
</template>
<script>
import Bottom from '../HP/BottomPage.vue';
import TopNavigation from "../HP/TopNavigationB.vue";
import OrderDetails from "./OrderDetailsPage.vue";
import LeaveWord from "./LeaveWordPage.vue";
// import LeaveWord from "./liuyanban.vue";
import Confirmation from "./ConfirmationPage.vue";
import CutOffConfirmation from "./CutOffConfirmation.vue";
import BillOfLadingConfirmation from "./BillOfLadingConfirmation.vue";
import BillDetails from "./BillDetailsPage.vue";
import { myOrderDetail,billStatus } from "@/api/api";

export default {
    components:{
        Bottom,
        TopNavigation,
        OrderDetails,
        LeaveWord,
        Confirmation,
        CutOffConfirmation,
        BillOfLadingConfirmation,
        BillDetails, // 账单明细
    },
    data() {
        return {
            activeName: 'first',
            // 账单变动弹窗打开状态
            dialogTableVisible:false,
            canshu:{},
            headers:{
                token: localStorage.getItem('token')
            },
            totalMoney:0,
            // 文件列表
            fileList:[],
            parentMessage:{},
            bill_change:{
                other_cost:[],
                surcharge:[],
                boxtype:[],
                boxPrice:0,
                surchargePrice:0,
                otherPrice:0,
                linefee:0,
            },
            // 是否显示未读留言
            hiddenBadge:0,
            showTabFirst:false,
            showTabSecond:false,
            showTabThird:false,
            diaoyong:false,
        }
    },
    methods: {
        handleClick() {
            if(this.activeName == 'second'){
                this.hiddenBadge=0
                this.diaoyong=true
            }else{
                this.diaoyong=false
            }
        },
        async getDetails(){
            this.totalMoney = 0
            try {
                const res = await myOrderDetail({
                    order_id: this.$route.query.id
                },this.headers)
                
                if(res.code==1){
                    this.parentMessage = res.data

                    this.fileList = res.data.files
                    this.bill_change.surcharge=res.data.surcharge
                    this.bill_change.boxtype=res.data.boxtype
                    // 用户下单时  线路费后台已添加
                    // this.bill_change.linefee=Number(res.data.linefee)
                    this.bill_change.linefee=0
                    let boxList = []

                    if(this.bill_change.boxtype.length>0){
                        for (let i = 0; i < this.bill_change.boxtype.length; i++) {
                            // this.bill_change.boxPrice += Number(this.bill_change.boxtype[i].money) + Number(res.data.linefee)
                            this.bill_change.boxPrice += Number(this.bill_change.boxtype[i].money) + 0
                        
                            boxList.push(this.bill_change.boxtype[i].box_type)
                            
                            if(this.bill_change.boxtype[i].overweight==1){ //超重  
                                let weight_limit = this.bill_change.boxtype[i].weight_limit
                                for (let j = 0; j < weight_limit.length; j++) {
                                    if(Number(this.bill_change.boxtype[i].weight)>Number(weight_limit[j].min_weight) && Number(this.bill_change.boxtype[i].weight)<=Number(weight_limit[j].max_weight)){
                                        this.bill_change.boxPrice  += Number(weight_limit[j].overweight_fees)
                                    }
                                }
                            }
                        }
                    }

                    if(this.bill_change.surcharge.length>0){
                        for (let i = 0; i < this.bill_change.surcharge.length; i++) {
                            if(this.bill_change.surcharge[i].cost_unit==1){
                                if(this.bill_change.surcharge[i].box_cost!=null){
                                    this.bill_change.surcharge[i].box_cost.forEach(obj => {
                                        if(obj != null){
                                            Object.keys(obj).forEach(key => {
                                                if(boxList.includes(key)){
                                                    this.bill_change.surchargePrice += Number(obj[key])
                                                }
                                            });
                                        }
                                        
                                    });
                                }
                                
                            } else if(this.bill_change.surcharge[i].cost_unit==2){
                                // 票
                                // vote_cost
                                this.bill_change.surchargePrice += Number(this.bill_change.surcharge[i].vote_cost)
                            }   
                        }
                    }

                    if(res.data.other_cost!=null){
                        this.bill_change.other_cost=res.data.other_cost
                        if(this.bill_change.other_cost.length>0){
                            for (let i = 0; i < this.bill_change.other_cost.length; i++) {
                                if(this.bill_change.other_cost[i].cost_unit==1){
                                    if(this.bill_change.other_cost[i].box_cost!=null){
                                        this.bill_change.other_cost[i].box_cost.forEach(obj => {
                                            if(obj != null){
                                                Object.keys(obj).forEach(key => {
                                                    if(boxList.includes(key)){
                                                        this.bill_change.otherPrice += Number(obj[key])
                                                    }
                                                });
                                            }
                                            
                                        });
                                    }
                                    
                                } else if(this.bill_change.other_cost[i].cost_unit==2){
                                    // 票
                                    // vote_cost
                                    this.bill_change.otherPrice += Number(this.bill_change.other_cost[i].vote_cost)
                                }   
                            }
                        }
                    }


                    if (this.parentMessage.confirm_status==2) {
                        this.showTabFirst=true
                        this.activeName='fourth'
                    }else if (this.parentMessage.confirm_status==3 || this.parentMessage.confirm_status==31 || this.parentMessage.confirm_status==4) {
                        this.showTabFirst=true
                        this.showTabSecond=true
                        this.activeName='fifth'
                    }else if (this.parentMessage.confirm_status==5) {
                        this.showTabFirst=true
                        this.showTabSecond=true
                        // 文件中是否有51
                        const item = this.parentMessage.files.findIndex(item => item.type === 51)
                        if(item==-1){
                            this.showTabThird=false
                        }else{
                            this.showTabThird=true
                            this.activeName='sixth'
                        }
                    }

                    this.hiddenBadge = res.data.user_liuyan_num

                    if(this.parentMessage.order_status==6){
                        this.activeName='first'
                    }
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        getShowTabSecond(e){
            this.showTabSecond=e.second
            this.activeName='fifth'
        },
        // 确认账单
        async ConfirmBill(){
            try {
                const res = await billStatus({
                id: this.canshu.id
                },this.headers)
                if(res.code==1){
                    this.$message({
                        type:'success',
                        message:'账单确认成功'
                    })
                }else{
                    this.$message({
                        type:'error',
                        message:res.msg
                    })
                }
            } catch (error) {
                console.log(error,'失败');
            }
        }
    },
    mounted(){
        this.canshu = this.$route.params
        if(this.canshu.id){
            sessionStorage.setItem('itemId',this.canshu.id)
        }
        this.getDetails()
    }
}
</script>
    
<style style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}

.Booking{
    background: #F9F9F9;
}
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}


.el-breadcrumb{
    margin: 20px 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .el-breadcrumb__inner is-link{
        color: pink;
    }
}

:deep(.el-breadcrumb){
    .el-breadcrumb__inner{
        color: #999999 !important;
    }
    .bread{
        span{
            color: #0073F5 !important;
        }
    }
}


.detail-content{
    background: #fff;
    margin-bottom: 92px;
    .el-tabs{
        padding: 10px 32px;
    }

    :deep(.el-badge){
        .el-badge__content.is-fixed {
            right: 8px;
            top: 8px;
        }
    }

    ::v-deep .el-tabs__item.is-active {
        color: #0073F5;//选中
    }
    
    ::v-deep .el-tabs__item:hover {
        color: #0073F5;//hover
        // cursor: pointer;
    }
    // 普通字体颜色
    ::v-deep .el-tabs__item {
        color: #606260;//悬浮
        // cursor: pointer;
        font-size: 18px;
    }

    // 下划线颜色
    ::v-deep .el-tabs__active-bar {
        background-color: #0073F5;
    }
    

    .san{
        .tit{
            font-size: 18px;

            margin-top: 24px;
            margin-bottom: 18px;
        }
    }

    .xiaoji{
        text-align: right;
        margin-top: 18px;
    }

    .zongji{
        height: 80px;
        background: #fff;
        border-top: 1px solid#eee;

        display: flex;
        justify-content: space-between;
        align-items: center;

        margin-top: 32px;
        .left{
            margin-left: 32px;
            .yugu{
                display: flex;
                align-items: center;

                color: #999;
                font-size: 14px;

                margin-top: 8px;
                
            }
            span{
                color: #FE3300;
            }
        }

        .right{
            margin-right: 32px;

            .el-button{
                width: 100px;
                height: 40px;
                border-radius: 8px 8px 8px 8px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                font-style: normal;
                text-transform: none;
                border: 0;
            }
            .yulan{
                color: #0073F5;
            }
            .daochu{
                color: #0073F5;
                border: 1px solid #0073F5;
                margin-left: 16px;
            }
            .biandong{
                background: #0073F5;
                border-radius: 8px 8px 8px 8px;
                color: #fff;
                margin-left: 16px;
            }
        }
    }
}


.table{
    width: 100%;
    border-spacing: 0;

    border-bottom: solid 1px #eee;

    margin-top: 4px;

    .theader{
        height: 48px;
        background: #F9F9F9;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
    }
    .first{
        padding-left: 24px;
        // width: 320px;
    }
    .tbody{
        height: 68px;
        background: #fff;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        .queren{
            color: #0073F5;
            font-size: 14px;
            margin: 0;
        }

        .bohui{
            color: #FE3300;
            font-size: 14px;
            margin: 0;
        }

        .xie{
            color: #999;
        }
    }
    
}
</style>